// smvm_recording_reducers

import {
  smvm_get_answer_assessee_reducers,
  smvm_get_list_answer_assessee_reducers,
  smvm_set_answer_assessee_reducers,
} from "../reducers/answerAssesseeReducers";
import {
  smvm_get_aspect_guide_reducers,
  smvm_get_assessee_guide_reducers,
  smvm_get_assessor_guide_reducers,
} from "../reducers/guideReducers";
import {
  smvm_get_privatenote_reducers,
  smvm_set_privatenote_reducers,
} from "../reducers/privateNoteReducers";
import { smvm_recording_reducers } from "../reducers/recordingReducers";
import {
  smvm_room_status_reducers,
  smvm_setEndSession_reducers,
  smvm_user_leave_reducers,
} from "../reducers/sessionMethodReducers";

const modulSessionMethodVideoModul = {
  smvm_recording: smvm_recording_reducers,
  smvm_set_privatenote: smvm_set_privatenote_reducers,
  smvm_get_privatenote: smvm_get_privatenote_reducers,
  smvm_set_answer_assessee: smvm_set_answer_assessee_reducers,
  smvm_get_answer_assessee: smvm_get_answer_assessee_reducers,
  smvm_get_list_answer_assessee: smvm_get_list_answer_assessee_reducers,
  smvm_get_assessor_guide: smvm_get_assessor_guide_reducers,
  smvm_get_assessee_guide: smvm_get_assessee_guide_reducers,
  smvm_get_aspect_guide: smvm_get_aspect_guide_reducers,
  smvm_room_status: smvm_room_status_reducers,
  smvm_setEndSession: smvm_setEndSession_reducers,
  smvm_user_leave: smvm_user_leave_reducers,
};

export default modulSessionMethodVideoModul;
